import React from 'react';
import { TouchableOpacityProps } from 'react-native';
import { GridList, Iffy } from '@alucio/lux-ui';
import { ListFieldConfig, SortableGridListHeaderText } from 'src/components/DNA';
import { SortDir } from 'src/components/DNA/hooks/useSort';

interface GridListSingleColumnHeaderProps extends TouchableOpacityProps {
  field: ListFieldConfig,
  toggleSort: (string) => void
  sortDir: SortDir | keyof typeof SortDir,
}

const GridListSingleColumnHeader: React.FC<GridListSingleColumnHeaderProps> = React.memo((props) => {
  const { field, sortDir, toggleSort, ...rest } = props

  return (
    <GridList.Col {...rest}>
      <Iffy is={field.fieldLabel.length > 0}>
        <SortableGridListHeaderText
          lable={field.fieldLabel}
          isSortedAsc={sortDir === SortDir.asc}
          onPress={() => toggleSort(field.fieldName)}
          isActive={sortDir !== SortDir.none}
        />
      </Iffy>
    </GridList.Col>
  )
})

export default GridListSingleColumnHeader;
